import { HYDRATE_CLIENT_STATE } from './actions';

type HydrateClientState = {
    dateLastShown: string;
    disableModalForTesting: boolean;
    hasLoggedInBefore: boolean;
    pageSize: number | 'all';
    token: string;
};

/* ACTION CREATORS */
export const hydrateClientState = (params: HydrateClientState) => ({
    payload: { ...params },
    type: HYDRATE_CLIENT_STATE,
});
